import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const createStore = (initialState) => {
    initialState.checked = {};

    return new Vuex.Store({
        state: initialState,
        mutations: {
            setChecked(state, { labelId, checked }) {
                state.checked = {
                    ...state.checked,
                    [labelId]: checked,
                }
            }
        }
    });
}